import { useContext } from 'react';
import { ComplianceRequestContext, ConfigContext } from '@/context';
import { ConsentHistory } from './ConsentHistory';
import { PrivacyDisclosures } from './PrivacyDisclosures';
import { PrivacyOptions } from './PrivacyOptions';
import { PrivacyRequests } from './PrivacyRequests';
import { ViewValues } from '@/constants/views';

type Props = {
  setSelectedView: (view: ViewValues) => void;
  theme: 'light' | 'dark' | 'brand' | 'classic';
};

export function DataPrivacy({ setSelectedView, theme }: Props) {
  const { complianceRequestList: { loaded = false, requests } = {} } =
    useContext(ComplianceRequestContext);
  const {
    privacyDisclosuresEnabled,
    consentHistoryEnabled,
    privacyRequestsEnabled,
  } = useContext(ConfigContext);

  return (
    <div className="flex flex-col space-y-6">
      {privacyDisclosuresEnabled && <PrivacyDisclosures />}
      {consentHistoryEnabled && <ConsentHistory />}
      {privacyRequestsEnabled && (
        <>
          {loaded && requests && requests.length > 0 && (
            <PrivacyRequests
              loading={!loaded}
              requests={requests}
              theme={theme}
            />
          )}
          <PrivacyOptions setSelectedView={setSelectedView} />
        </>
      )}
    </div>
  );
}
